import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setStockoutproductSorting} from 'store/slice/ManufSlice';

export default function StockoutproductListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.stockoutproductDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setStockoutproductSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={2} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('title')}> Title </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('stockoutreqid')}> Stock Out Req Id </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('productid')}> Product Id </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('productname')}> Product Name </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('qty')}> Qty </Typography></Grid>

      </Grid>
      
    )
}